import { yaBukanFlagOptions } from '@/constants/flagAndCategory';
import { customerStatusOptions } from '@/constants/status';

const headers = [
  { title: 'Kode', key: 'code', sortable: true },
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'PKP', key: 'is_pkp', sortable: true },
  { title: 'Alamat', key: 'address', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'Kode', key: 'code', type: 'text' },
  { title: 'Nama', key: 'name', type: 'text' },
  {
    title: 'Pengusaha Kena Pajak (PKP)',
    key: 'is_pkp',
    type: 'select',
    selectOptions: yaBukanFlagOptions,
  },
  { title: 'Alamat', key: 'address', type: 'text' },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: customerStatusOptions.map(({ value, title }) => ({ value, title })),
  },
  { title: 'Untuk Perhatian', key: 'contact_attention', type: 'text' },
  { title: 'In Charge', key: 'contact_incharge', type: 'text' },
];

export { filters, headers };
